<div class="search_mobile_open">
  <div class="content">
    <div class="offers_filter_tags" *ngIf="tagsSelected.length">
      <ng-container *ngFor="let t of tagsSelected">
        <span class="tag" (click)="removeTag(t)" [style.background-color]="getValueColorTag(t)">
          <fa-icon [icon]="getFaIcon('faTimesCircle')"></fa-icon>
          {{t.tagName}}
        </span>
      </ng-container>
    </div>
    <div class="section_universe">
      <h2>Votre univers</h2>
      <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(1)" [checked]="universIsSelected(1)" value="1">
            <span class="radioLabel">
              Loisirs et Découvertes
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(2)" [checked]="universIsSelected(2)" value="2">
            <span class="radioLabel">
              Compétitions
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(3)" [checked]="universIsSelected(3)" value="3">
            <span class="radioLabel">
              Formations Professionnelles
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(4)" [checked]="universIsSelected(4)" value="4">
            <span class="radioLabel">
              Entreprises
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(6)" [checked]="universIsSelected(6)" value="6">
            <span class="radioLabel">
              Apprendre et se perfectionner
            </span>
          </mat-radio-button>
        </div>
      </mat-radio-group>


    </div>

    <div class="offers_filter_tags_more" id="tags">
      <ng-container *ngFor="let t of tags">
        <span *ngIf="isInTagSelected(t?.tagName)" class="tag" (click)="addTag(t)"
          [style.background-color]="getValueColorTag(t)"> {{t.tagName}} </span>
      </ng-container>

    </div>
  </div>

  <div class="search_container">
    <form [formGroup]="searchForm" class="search_bar">
      <input ngx-google-places-autocomplete (onAddressChange)="getAddressSearch($event)" type="text"
        formControlName="keyword" placeholder="Choix de la ville...">
      <fa-icon [icon]="valueInput ? getFaIcon('faTimes') :  getFaIcon('faSearch')"
        (click)="valueInput ? resetSearch(): null"></fa-icon>
    </form>
    <div class="validate" (click)="getAddressSearch(null, true)" appChangeColorTheme attribute="bgc">
      <fa-icon [icon]="getFaIcon('faCheck')"></fa-icon>
      <p>Confirmer</p>
    </div>
  </div>

  <!-- <fa-icon [ngClass]="{close: openSearch}" [icon]="!openSearch?  faSearch : faCheck" (click)="openDivSearch()"></fa-icon> -->
</div>